export default __webpack_public_path__ + "static/media/forcastFilter.553e8a87.svg";